import { SelectOption } from '@cks-internal/react-base';
import { useMemo } from 'react';
import { ProductListingModel, ProductOptionModel } from '../models/ProductListingModel.ts';

export function useProductViewSelectOptions(
  product: ProductListingModel | undefined,
  productOption: ProductOptionModel | undefined
) {
  const formSelect: SelectOption[] = useMemo(() => {
    if (!product?.ProductOptions) {
      return [];
    }
    return product?.ProductOptions.map((val) => {
      const descriptionLines: string[] = [];
      if (val.ExpiresInDays != null) {
        const dayLabel = val.ExpiresInDays === 1 ? 'day' : 'days';
        descriptionLines.push(`Expires in: ${val.ExpiresInDays} ${dayLabel}`);
      }

      const description = val.Description?.trim();
      if (description) {
        descriptionLines.push(description);
      }

      return {
        Label: val.Form,
        Value: val.FormId,
        DescriptionLines: descriptionLines.length > 0 ? descriptionLines : undefined
      };
    });
  }, [product?.ProductOptions]);

  const flavourSelect: SelectOption[] = useMemo(() => {
    if (!productOption) {
      return [];
    }
    return productOption.Flavors;
  }, [productOption]);

  const strengthSelect: SelectOption[] = useMemo(() => {
    if (!productOption) {
      return [];
    }

    const toReturn: SelectOption[] = [];
    productOption.Strengths.forEach((val) => {
      if (toReturn.some((v) => v.Value === val.Id)) {
        return;
      }
      toReturn.push({ Label: `${val.Strength} ${val.StrengthUnit}`, Value: val.Id });
    });
    toReturn.sort((a, b) => {
      const numA = parseFloat(a.Label) || 0;
      const numB = parseFloat(b.Label) || 0;
      return numA - numB;
    });
    return toReturn;
  }, [productOption]);

  return { formSelect, flavourSelect, strengthSelect };
}
